import axios, { getData } from 'lib/axios'

export const getMyLearning = async (status) => {
  // query params is temporary until we integrate with bootcamp as well
  const { data } = await axios.get(`adx_edu/my_learning/${status}?type=course`).then(getData)
  return data
}